"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationBuilder = void 0;
var notification_base_builder_1 = require("./notification-base-builder");
var notification_1 = require("../structs/notification");
var notification_schedule_1 = require("../structs/notification-schedule");
var NotificationBuilder = (function (_super) {
    __extends(NotificationBuilder, _super);
    function NotificationBuilder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.Model = notification_1.Notification;
        return _this;
    }
    Object.defineProperty(NotificationBuilder.prototype, "channels", {
        get: function () {
            return this.data.channels;
        },
        enumerable: false,
        configurable: true
    });
    NotificationBuilder.prototype.setChannels = function (channels) {
        this.data.channels = channels;
        return this;
    };
    Object.defineProperty(NotificationBuilder.prototype, "schedules", {
        get: function () {
            return this.data.schedules;
        },
        enumerable: false,
        configurable: true
    });
    NotificationBuilder.prototype.setSchedules = function (schedules) {
        this.data.schedules = schedules.map(function (schedule) {
            if (!schedule || typeof schedule !== 'object') {
                throw new Error('Invalid schedule found in array. Only schedules of type Object expected.');
            }
            var container = schedule;
            return notification_schedule_1.NotificationSchedule.Builder.setId(container.id)
                .setDomainId(container.domainId)
                .setAudience(container.audience)
                .setDeliverySpec(container.deliverySpec)
                .setNotificationGroup(container.notificationGroup)
                .setStatus(container.status)
                .setAbTest(container.abTest)
                .build();
        });
        return this;
    };
    return NotificationBuilder;
}(notification_base_builder_1.NotificationBaseBuilder));
exports.NotificationBuilder = NotificationBuilder;
//# sourceMappingURL=notification-builder.js.map